function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.2478 36.1831L21.0298 49.6038L23.2579 49.4599L23.7772 36.1831H19.2478Z",
  fill: "#F6B9A6"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.72226 49.4462H3.72087L7.89583 38.8327L3.17515 37.8999L1.72226 49.4462Z",
  fill: "#F6B9A6"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.3309 7.335C23.1588 5.45446 23.1317 2.33693 22.9191 0H11.6063L15.1417 12.803C15.3077 15.5154 15.7459 18.2111 16.4476 20.8365C16.9137 22.5807 17.4979 24.3043 17.7162 26.0964C17.8802 27.4415 17.8347 28.8019 17.8564 30.1565C17.9022 33.0489 18.3337 35.9607 18.8754 38.7985C19.4075 41.5856 19.725 44.4326 20.2258 47.2446C21.4357 47.2459 22.6456 47.247 23.8555 47.2481C23.9531 47.2483 24.0609 47.2444 24.1313 47.177C24.204 47.1073 24.2102 46.9951 24.2117 46.8942C24.3279 38.9664 24.2135 31.0564 24.0201 23.0991C24.003 22.3984 23.986 21.6978 23.9691 20.9973C23.8581 16.4398 23.7467 11.877 23.3309 7.335Z",
  fill: "#3A3A6A"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.76822 0C8.02195 3.92849 9.03818 7.71943 8.89165 11.7256C8.85232 12.7983 8.97894 14.077 9.38181 15.067C9.39829 15.1078 9.41477 15.155 9.3947 15.1939C9.37284 15.2362 9.31981 15.2483 9.27494 15.2643C9.08647 15.3313 8.97095 15.5573 9.02724 15.7495C9.05661 15.8496 9.1258 15.9452 9.1072 16.0477C9.09806 16.0982 9.06836 16.1423 9.03932 16.1847C8.50363 16.9732 8.03794 17.8112 7.65563 18.6845C7.31591 19.4602 7.27202 20.2607 6.93572 21.0319C6.06602 23.0255 5.30891 25.0501 4.5877 27.1018C4.037 28.6684 3.4845 30.2417 3.16404 31.8711C2.17261 36.9115 1.27991 42.0525 0.972656 47.1847C2.34557 47.1739 3.71833 47.1631 5.09124 47.1522C5.25441 47.1509 5.42966 47.1458 5.56101 47.0491C5.67083 46.9681 5.73006 46.8373 5.78439 46.7121C7.53945 42.6704 8.76747 38.4981 9.98244 34.2689C10.5353 32.3438 11.0912 30.4103 11.9305 28.5917C15.3868 21.1027 17.347 12.9729 18.6995 4.88892C18.9461 3.41565 19.5513 1.62387 19.7617 0H7.76822Z",
  fill: "#4C4981"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.9991 50.7905C29.9997 50.7743 30.0001 50.758 29.9999 50.7417C29.9924 49.8485 28.9274 49.5848 28.2576 49.3457C26.9618 48.8835 25.6956 48.3073 24.4208 47.7897C24.0572 47.6422 23.7172 47.5814 23.3453 47.7367C23.156 47.8157 23.0066 47.965 22.8405 48.0849C22.2296 48.5263 21.2483 48.5702 20.7194 47.9624C20.6682 47.9036 20.6248 47.8359 20.5597 47.7928C20.4947 47.7496 20.398 47.74 20.3449 47.7973C20.2501 47.8997 20.2394 48.324 20.21 48.4618C20.1496 48.7464 20.1126 49.0347 20.0907 49.3247C20.0496 49.8669 20.0636 50.4117 20.0778 50.9549C20.0811 51.0819 20.0862 51.2149 20.1503 51.3243C20.297 51.5755 20.9325 51.5128 21.1905 51.5216C21.5992 51.5355 22.0083 51.5353 22.4172 51.5321C23.0159 51.5273 23.6147 51.4986 24.2132 51.4986C25.3571 51.4986 26.5006 51.4754 27.6441 51.457C28.2316 51.4474 28.8249 51.4653 29.4114 51.4355C29.7844 51.4164 29.9846 51.1365 29.9991 50.7905Z",
  fill: "#873465"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.9082 50.7905C10.9089 50.7743 10.9092 50.758 10.909 50.7417C10.9015 49.8485 9.83651 49.5848 9.16669 49.3457C7.87096 48.8835 6.60475 48.3073 5.3299 47.7897C4.96636 47.6422 4.62631 47.5814 4.25445 47.7367C4.06517 47.8157 3.9157 47.965 3.7496 48.0849C3.13869 48.5263 2.15738 48.5702 1.62854 47.9624C1.57731 47.9036 1.5339 47.8359 1.4688 47.7928C1.40386 47.7496 1.3071 47.74 1.25407 47.7973C1.15926 47.8997 1.1485 48.324 1.11912 48.4618C1.05875 48.7464 1.02171 49.0347 0.999847 49.3247C0.958728 49.8669 0.97276 50.4117 0.986956 50.9549C0.99022 51.0819 0.995278 51.2149 1.0594 51.3243C1.20609 51.5755 1.84164 51.5128 2.09962 51.5216C2.50836 51.5355 2.91743 51.5353 3.32633 51.5321C3.925 51.5273 4.52384 51.4986 5.12235 51.4986C6.26618 51.4986 7.40967 51.4754 8.55317 51.457C9.14075 51.4474 9.73404 51.4653 10.3205 51.4355C10.6935 51.4164 10.8937 51.1365 10.9082 50.7905Z",
  fill: "#873465"
});

var SvgLegsThumb2 = function SvgLegsThumb2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 53,
    height: 50,
    viewBox: "0 0 31 52",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLegsThumb2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/legs-thumb-2.81526600.svg";
export { ForwardRef as ReactComponent };